<template>
  <v-container fluid>
    <v-skeleton-loader :loading="loading" transition-group="scale-transition" type="list-item-three-line">
      <v-card flat class="mx-auto">
        <v-card-text>
          <v-form ref="settingsForm">
            <v-row>
              <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
                <v-subheader>Politica di blocco attività</v-subheader>
              </v-col>
              <v-col xl="10" lg="10" md="10" sm="10" xs="12">
                <v-chip-group v-model="settings.lockPolicy" active-class="green white--text" mandatory>
                  <v-chip v-for="lp in lockPolicies" :key="lp.code" :value="lp.code">
                    <v-icon left v-if="lp.code === settings.lockPolicy">mdi-check</v-icon>
                    {{ lp.description }}
                  </v-chip>
                </v-chip-group>
                <span class="caption">{{ hint }}</span>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
      <v-footer fixed>
        <v-spacer></v-spacer>
        <v-btn color="green" dark :loading="operation" @click="save()">Salva</v-btn>
      </v-footer>
    </v-skeleton-loader>

    <notify ref="refNotify"></notify>
  </v-container>
</template>

<script>
import NotifyVue from '../dialog/Notify.vue';
import apiRepository from '../../api/api-repository';

export default {
  name: 'SettingsView',

  components: {
    'notify': NotifyVue
  },

  data: ()=> ({
    loading: true, // gestione dello skeleton loader.
    settings: new Object(), // oggetto delle impostazioni.
    lockPolicies: [ ], // lista delle lock policies disponibili.
    operation: false, // gestione dell'operazione.
  }),

  computed: {
    hint(){
      switch(this.settings.lockPolicy){
        case 'NO_LOCK': return 'Gli utenti possono inserire, modificare e cancellare le loro attività in qualunque periodo';
        case 'DAILY':   return 'Gli utenti possono inserire, modificare e cancellare le loro attività nell\'arco della giornata corrente';
        case 'WEEKLY':  return 'Gli utenti possono inserire, modificare e cancellare le loro attività nell\'arco della settimana corrente';
        case 'MONTHLY': return 'Gli utenti possono inserire, modificare e cancellare le proprie attività nell\'arco del mese corrente';
        default:        return '';
      }
    }
  },

  methods: {
    async load(){
      try{
        const res1 = await apiRepository.settings().listLockPolicies(); // attendo il risultato della chiamata.
        this.lockPolicies = res1.data; // carico il risultato sulla lista delle policies disponibili.
        const res2 = await apiRepository.settings().find(); // attendo il risultato della chiamata.
        this.settings = res2.data; // carico il risultato sull'oggetto delle impostazioni.
        this.loading = false;
      }
      catch(e){
        console.error(e); // loggo l'errore riscontrato.
        this.$refs.refNotify.notify('error', e.message); // notifico l'errore riscontrato.
      }
    },

    async save(){
      this.operation = true;
      const req = { lockPolicy: this.settings.lockPolicy };

      try{
        const res1 = await apiRepository.settings().update(req);
        this.operation = false;
        this.$refs.refNotify.notify('success', res1.message);

        this.loading = true;
        const res2 = await apiRepository.settings().find(); // attendo il risultato della chiamata.
        this.settings = res2.data; // carico il risultato sull'oggetto delle impostazioni. 
        this.loading = false;
      }
      catch(e){
        console.error(e); // loggo l'errore riscontrato.
        this.$refs.refNotify.notify('error', e.message); // notifico l'errore riscontrato.
      }
    }
  },

  created(){
    this.load();
  }
}
</script>